// import { ifAuthenticated } from "@/Modules/User/Routes/guards"

export default [
  {
    path: "/customers",
    name: "Customers",
    meta: { title: "Stranke" },
    component: () => import(/* webpackChunkName: "Customers List" */ "@/Modules/Customer/Views/List"),
    children: [
      {
        path: "new",
        name: "New Customer",
        meta: { title: "Nova stranka" }
      },
      {
        path: "edit/:id",
        name: "Edit Customer (List)"
      }
    ]
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/customers/details/:id",
    name: "Customer Details",
    component: () => import(/* webpackChunkName: "Customers Details" */ "@/Modules/Customer/Views/Details"),
    children: [
      {
        path: "edit",
        name: "Edit Customer (Details)"
      }
    ]
    // beforeEnter: ifAuthenticated
  }
]
